import React, { useMemo } from "react";
import Form from "./Form";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaArrowCircleRight } from "react-icons/fa";
import Bgmotion from './BGMotion.jsx';
// import offers from '../../public/offers.json';
import { useEffect } from "react";
import { useState } from "react";
import { TiDeleteOutline } from "react-icons/ti";

function Hero() {

  const [offers, setOffers] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/offers.json")
      .then((res) => res.json())
      .then((data) => {
        setOffers(data);
        setIsVisible(data?.showPopup ?? false);
      })
      .catch((err) => console.error("Failed to load offers.json:", err));
  }, []);



  // Memoize animation configurations
  const animations = useMemo(() => ({
    badge: {
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 1, y: 0 },
      transition: { duration: 0.5, delay: 0.1 }
    },
    heading: {
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 1, y: 0 },
      transition: { duration: 0.5, delay: 0.2 }
    },
    description: {
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 1, y: 0 },
      transition: { duration: 0.5, delay: 0.3 }
    },
    cta: {
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 1, y: 0 },
      transition: { duration: 0.5, delay: 0.4 }
    },
    formContainer: {
      initial: { opacity: 0, x: 20 },
      animate: { opacity: 1, x: 0 },
      transition: { duration: 0.5, delay: 0.5 }
    },
    pulse: {
      animate: { scale: [1, 1.2, 1] },
      transition: { duration: 1.5, repeat: Infinity }
    },
    arrow: {
      animate: { x: [0, 5, 0] },
      transition: { duration: 1, repeat: Infinity }
    },
    buttonHover: { scale: 1.05 },
    buttonTap: { scale: 0.95 }
  }), []);

  return (
    <div className="">
      {isVisible && offers.image && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative w-[90%] max-w-md sm:max-w-xl md:max-w-2xl bg-white rounded-lg shadow-lg overflow-hidden">

            {/* Close Button */}
            <button
              onClick={() => setIsVisible(false)}
              className="absolute top-2 right-2 z-50 text-white hover:text-red-300 transition-colors bg-black bg-opacity-40 rounded-full p-1"
            >
              &times;
            </button>

            {/* Image */}
            <img
              src={offers.image}
              alt="Popup Banner"
              className="w-full h-auto object-cover"
            />

            {/* Contact Us Button (bottom-right overlapping the image) */}
            {offers.contactButton?.enabled && (
              <div className="absolute bottom-4 right-4 z-40">
                <button
                  onClick={() => {
                    setIsVisible(false);
                    navigate('/contactus');
                  }}
                  className="px-4 py-2 bg-green-600 text-white text-sm sm:text-base rounded-full shadow-md hover:bg-green-700 transition-all font-semibold"
                >
                  {offers.contactButton.label || "Contact Us"}
                </button>
              </div>
            )}
          </div>
        </div>
      )}


      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 md:py-20 lg:py-24">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 xl:gap-24">
          <Bgmotion />
          {/* Left Section - Content */}
          <div className="flex flex-col justify-start py-5">
            <div className="max-w-2xl">
              {/* Badge with animation */}
              <motion.div
                {...animations.badge}
                className="mb-8 lg:mb-10"
              >
                <div className="flex items-center justify-center gap-2 rounded-full px-2 py-2.5 font-medium text-emerald-800 shadow-sm ring-1 ring-inset ring-emerald-200 whitespace-nowrap overflow-x-auto hover:scale-105 transition-transform duration-300">
                  <div className="flex items-center justify-between gap-2">
                    <motion.span
                      {...animations.pulse}
                      className="h-2 w-2 rounded-full bg-emerald-500 flex-shrink-0"
                    />
                    <span>What's new</span>
                  </div>
                  <div className="flex items-center justify-between gap-1">
                    <motion.span
                      {...animations.pulse}
                      transition={{ ...animations.pulse.transition, delay: 0.3 }}
                      className="h-2 w-2 rounded-full bg-emerald-500 flex-shrink-0"
                    />
                    <span>Explore the latest features</span>
                  </div>
                </div>
              </motion.div>

              {/* Heading with animation */}
              <motion.h1
                {...animations.heading}
                className="text-3xl md:text-5xl lg:text-[3.5rem] font-bold leading-tight text-gray-900"
              >
                Invest Smart,{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-700">
                  Grow Wealth
                </span>, Secure Your Future!
              </motion.h1>

              {/* Description with animation */}
              <motion.p
                {...animations.description}
                className="mt-6  md:text-sm lg:text-xl leading-relaxed text-gray-600"
              >
                Unlock the potential of the stock market with valuable insights and practical strategies. Whether you're a beginner or an experienced investor, take control of your financial journey and work toward long-term success.
              </motion.p>

              {/* CTA Buttons with animations */}
              <motion.div
                {...animations.cta}
                className="mt-8 flex flex-wrap gap-4"
              >
                <motion.div whileHover={animations.buttonHover} whileTap={animations.buttonTap}>
                  <Link
                    to="/contactus"
                    className="flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-green-600 to-green-600 px-6 py-3.5 text-sm font-semibold text-white shadow-lg hover:shadow-xl transition-all"
                  >
                    Reach Us
                    <motion.span {...animations.arrow}>
                      <FaArrowCircleRight />
                    </motion.span>
                  </Link>
                </motion.div>

                <motion.div whileHover={animations.buttonHover} whileTap={animations.buttonTap}>
                  <Link
                    to="/services"
                    className="flex items-center justify-center gap-2 rounded-xl bg-white px-6 py-3.5 text-sm font-semibold text-emerald-600 shadow-lg hover:shadow-xl ring-1 ring-emerald-200 hover:bg-emerald-50 transition-all"
                  >
                    Our Services
                  </Link>
                </motion.div>
              </motion.div>
            </div>
          </div>

          {/* Right Section - Form */}
          <div className="relative lg:mt-0">
            <motion.div
              {...animations.formContainer}
              className="sticky top-8"
            >
              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br bg-green-600  shadow-2xl ring-1 ring-gray-900/5 hover:shadow-3xl transition-shadow duration-500 mt-4">
                <div className="relative pt-8 sm:px-10 sm:py-12">
                  <div className="mx-auto max-w-md px-4">
                    <motion.h2
                      whileHover={{ scale: 1.02 }}
                      className="text-2xl font-bold text-white mb-2"
                    >
                      Get Started Today
                    </motion.h2>
                    <motion.p
                      whileHover={{ scale: 1.01 }}
                      className="text-emerald-100 mb-6"
                    >
                      Fill out the form to begin your investment journey
                    </motion.p>
                  </div>
                  <Form />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Hero);